import { render, staticRenderFns } from "./mySpace.vue?vue&type=template&id=5953d7e2&"
import script from "./mySpace.vue?vue&type=script&lang=js&"
export * from "./mySpace.vue?vue&type=script&lang=js&"
import style0 from "./mySpace.vue?vue&type=style&index=0&id=5953d7e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports